import { render, staticRenderFns } from "./ContextMenu.vue?vue&type=template&id=08637442"
import script from "./ContextMenu.vue?vue&type=script&lang=js"
export * from "./ContextMenu.vue?vue&type=script&lang=js"
import style0 from "./ContextMenu.vue?vue&type=style&index=0&id=08637442&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports